import { useCompleteVideoVisitMeeting } from "@/features/AudioVideo/network/useCompleteVideoVisitMeeting";
import { useSearch } from "@tanstack/react-router";
import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { confirmationOpenAtom } from "../atoms/videoCallAtoms";
export const useCompleteVideoCall = () => {
  const { encounterId } = useSearch({ from: "/patient/$patientId" });
  const { mutate: completeMeeting } = useCompleteVideoVisitMeeting();
  const setConfirmationOpen = useSetAtom(confirmationOpenAtom);

  const handleSuccessfulCompletion = useCallback(async () => {
    await completeMeeting({
      encounterId: encounterId?.toString() || "",
      completed: true,
    });
    setConfirmationOpen(false);
  }, [completeMeeting, encounterId, setConfirmationOpen]);

  const handleUnsuccessfulCompletion = useCallback(async () => {
    await completeMeeting({
      encounterId: encounterId?.toString() || "",
      completed: false,
    });
    setConfirmationOpen(false);
  }, [completeMeeting, encounterId, setConfirmationOpen]);

  return { handleSuccessfulCompletion, handleUnsuccessfulCompletion };
};
